import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiConfig } from '../Config/api.config';
@Injectable({
  providedIn: 'root'
})
export class UserElectricityMeterService {

  constructor(private http: HttpClient) {}

  postElectricityMeter(userSession: string, meterName: string, meterNumber: string, requestType: string): Observable<any> {
    const headers = new HttpHeaders({
      'X-Api-Key': ApiConfig.apiKey,
      'Authorization': `Bearer ${userSession}`
    });

    const request = {
      meterName,
      meterNumber,
      requestType
    };
    return this.http.post(
      `${ApiConfig.baseUrl}/UserElectricityMeter/add-meter`,
      request,
      {
        headers
      }
    );
  }
}